export const SORT_OPTIONS = [
  'Alphabetically (A-Z)',
  'Alphabetically (Z-A)',
  'Best Sellers',
  'Price (Low to High)',
  'Price (High to Low)',
  'Recently Added'
];